import {useMutation} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {readAccountBasicInfoApi} from "../../../../../api/correspondent/CorresspondentApi";

export const useReadAccountBasicInfo = () => {
    const {handleModal} = useModal();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: string) => readAccountBasicInfoApi(data),
        onSuccess: () => {
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
